<template>
  <div class="v-container">
    Nos Articles
  </div>
</template>

<style scoped>
.v-container {
  font-weight: bold;
  font-size: 22px;
  color: #ef6c00;
  border-top: 4px solid #ef6c00;
  padding-top: 0.5em;
}
</style>

<script>
export default {
  name: "Separator"
};
</script>

<style scoped>
</style>
